{
    "l_first_name": "Prénom",
    "l_last_name": "Nom de famille",
    "l_sex": "Sexe",
    "l_year_born": "Année de naissance",
    "l_occupation": "Profession",
    "l_no_results": "Aucun résultat trouvé",
    "l_condition_include": "inclut",
    "l_search_settings": "Paramètres de recherche",
    "l_male": "masculin",
    "l_female": "féminin",
    "l_academic_title": "Titre académique",
    "l_confession": "Confession",
    "l_dienstgrad": "Grade militaire",
    "l_deceived": "Décédé",
    "l_wohnorte": "Lieux de résidence",
    "l_buergerorte": "Lieux de citoyenneté",
    "l_directories": "Répertoires",
    "l_remarks": "Remarques",
    "l_sources": "Sources",
    "l_parties": "Partis",
    "l_einsitze": "Sièges",
    "l_conncetions": "Connexions",
    "l_picture": "Image",
    "l_functions": "Fonctions",
    "l_function": "Fonction",
    "l_dict_dnb": "Catalogue de la Bibliothèque nationale allemande",
    "l_dict_hls": "Dictionnaire historique de la Suisse (DHS)",
    "l_time_join": "Date d'adhésion",
    "l_time_exit": "Date de sortie",
    "l_wahlkreis": "Circonscription électorale",
    "l_wahlkreise": "Circonscriptions électorales",
    "l_from": "de",
    "l_until": "jusqu'à",
    "l_since": "depuis",
    "l_fraktion": "Groupe parlementaire",
    "l_fraktionen": "Groupes parlementaires",
    "l_all": "tous",
    "l_born_before": "Né avant",
    "l_born_after": "Né après",
    "l_party_membership": "Appartenance à un parti",
    "l_short_name": "Nom abrégé",
    "l_mandates": "Mandats",
    "l_political_activities": "Activités politiques",
    "l_email": "Email",
    "l_email_private": "Email privé",
    "l_mobile": "Mobile",
    "l_mobile_private": "Mobile privé",
    "l_telephone": "Téléphone",
    "l_telephone_private": "Téléphone privé",
    "l_address": "Adresse",
    "l_anrede": "Salutation",
    "l_party": "Parti",
    "l_zip_code": "Code postal",
    "l_spouse": "Conjoint",
    "l_zivilstand": "État civil",
    "l_search": "chercher",
    "l_reset": "réinitialiser",
    "l_männlich": "masculin",
    "l_weiblich": "féminin",
    "l_gremium": "Collège",
    "l_title": "Titre",
    "l_type": "Type",
    "l_date": "Date",
    "l_time": "Heure",
    "l_traktanden": "Points à l'ordre du jour",
    "l_number_short": "N°",
    "l_documents": "Documents",
    "l_video": "Vidéo",
    "l_members": "Membres",
    "l_additional_infos": "Informations supplémentaires",
    "l_kommission": "Commission",
    "l_kommissionen": "Commissions",
    "l_sitzungen": "Séances",
    "l_contact_data": "Coordonnées",
    "h1_fraktionen": "Groupes parlementaires",
    "h1_kommissionen": "Commissions",
    "h1_mitglieder": "Membres",
    "h1_sitzungen": "Séances du Conseil d'État et des Commissions",
    "h1_wahlkreise": "Circonscriptions électorales du canton de Zurich",
    "h1_personen": "Membres du Conseil d'État de Zurich depuis 1803",
    "h1_kantonsrat": "Conseil d'État",
    "st_search_persons": "Recherche de personnes",
    "l_data": "Données",
    "l_ort": "Lieu",
    "l_geschaefts_art": "Type d'affaire",
    "h1_geschaefte": "Affaires",
    "l_pendent_bei": "En instance auprès de",
    "l_beginn": "Début",
    "l_role": "Rôle",
    "l_participation": "Participation",
    "l_direktion": "Direction",
    "l_politische_gemeinde": "Commune politique",
    "l_ablauf": "Déroulement",
    "l_status": "Statut",
    "l_frist": "Délai",
    "l_sitzungs_datum": "Date de séance",
    "l_geschaefte": "Affaires"
}